export default __webpack_public_path__ + "static/media/cooking-video-mobile.8e8546c6.mp4";